import { useState } from "react";
import { toast } from "sonner";
import Reveal from "@/components/Reveal";
import { CONTACT } from "@/lib/data";
import { submitLead } from "@/lib/api";

const initial = { name: "", email: "", phone: "", message: "" };

export default function Contact() {
  const [form, setForm] = useState(initial);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead({ type: "contact", ...form });
      toast.success("Message received. We'll be in touch soon.");
      setForm(initial);
    } catch {
      toast.error("Couldn't send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="bg-[#F5ECD7] text-[#121212]">
      <section className="section-pad pt-20 md:pt-28">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#9B2226] mb-5">Say Hi</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-9xl tracking-tighter leading-[0.95] break-words">
            Hashtag.<br/>TacoSoul<br/><span className="text-[#9B2226]">@gmail.com</span>
          </h1>
          <p className="mt-6 max-w-xl text-lg text-[#121212]/65">
            Press, partnerships, fan mail, recipe ideas — whatever it is, we
            actually read every message.
          </p>
          <a href={`mailto:${CONTACT.email}`} className="mt-8 inline-flex btn-red" data-testid="contact-email-link">
            Email Us Directly
          </a>
        </div>
      </section>

      <section className="section-pad pt-0">
        <div className="max-w-4xl mx-auto px-5 md:px-8 grid md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-4">
            <h2 className="font-display text-3xl md:text-4xl tracking-tighter">Or drop a line.</h2>
            <p className="mt-4 text-[#121212]/65">Quickest response time is via the form below.</p>
          </Reveal>
          <Reveal delay={120} className="md:col-span-8">
            <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
              <input data-testid="contact-name" required placeholder="Name *" value={form.name} onChange={set("name")} className="input-line-dark md:col-span-2" />
              <input data-testid="contact-email" required type="email" placeholder="Email *" value={form.email} onChange={set("email")} className="input-line-dark" />
              <input data-testid="contact-phone" placeholder="Phone (optional)" value={form.phone} onChange={set("phone")} className="input-line-dark" />
              <textarea data-testid="contact-message" required rows={4} placeholder="Your message *" value={form.message} onChange={set("message")} className="input-line-dark md:col-span-2 resize-none" />
              <div className="md:col-span-2 mt-6">
                <button data-testid="contact-submit" type="submit" disabled={loading} className="btn-red">
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
